import React, { useMemo } from 'react';

import { KeyClaimsIcon } from '@repo/ui/components/icons/key-claims-icon';
import { PlayIcon } from '@repo/ui/components/icons/play-icon';
import { Button } from '@repo/ui/components/ui/button';
import { Separator } from '@repo/ui/components/ui/separator';
import { formatSecondsToClosestMinuteOrHour } from '@repo/utils';

interface YtVideoCardActionButtonsProps {
  keyMomentsDuration: number;
  keyClaimsCount: number;
  onSkimClick?: () => void;
  onKeyPointsClick?: () => void;
}

export const YtVideoCardActionButtons: React.FC<
  YtVideoCardActionButtonsProps
> = ({ keyMomentsDuration, keyClaimsCount }) => {
  const totalKeyMomentsDuration = useMemo(
    () => keyMomentsDuration,
    [keyMomentsDuration],
  );

  const formattedTotalKeyMomentsDuration = useMemo(() => {
    const result = formatSecondsToClosestMinuteOrHour(totalKeyMomentsDuration);

    const number = result.number >= 0 ? result.number : 0;

    return {
      number,
      type: result.type,
    };
  }, [totalKeyMomentsDuration]);

  return (
    <div className="[--container-height:29px] cred-md:[--container-height:32px] 2xl:[--container-height:36px] 3xl:[--container-height:40px] w-full h-[var(--container-height)] flex items-center border-t border-[#C0C0C0]">
      <Button
        variant="ghost"
        size="sm"
        // onClick={(e) => {
        //   e.stopPropagation();
        //   onSkimClick?.();
        // }}
        className="w-1/2 shrink-0 bg-[#2979FF] h-[var(--container-height)] flex items-center gap-1 cred-md:gap-1.5 px-2 cred-md:px-2.5 cred-lg:px-3 cred-xl:px-3 py-1 cred-md:py-1 cred-lg:py-1.5 cred-xl:py-1.5 rounded-none hover:bg-[#2979FF]/90 text-white hover:text-white [&_svg]:size-2 cred-md:[&_svg]:size-2.5 cred-xl:[&_svg]:size-[11.5px] 3xl:[&_svg]:size-3"
      >
        <div className="size-[13px] cred-md:size-[14px] cred-xl:size-[15px] 3xl:size-4 shrink-0 flex items-center justify-center rounded-full bg-white text-[#2979FF]">
          <PlayIcon />
        </div>
        <span className="text-xs cred-md:text-[13px] cred-lg:text-sm 3xl:text-[15px] leading-none font-medium">
          SKIM
        </span>
        <div className="bg-white rounded-[4px] px-1 py-[3px] flex items-center justify-center">
          <span className="text-[11px] leading-none font-bold text-[#2979FF] 3xl:text-xs">
            {formattedTotalKeyMomentsDuration.number}{' '}
            {formattedTotalKeyMomentsDuration.type === 's'
              ? 's'
              : formattedTotalKeyMomentsDuration.type === 'm'
                ? 'min'
                : 'hrs'}{' '}
            watch
          </span>
        </div>
      </Button>
      <Separator
        orientation="vertical"
        className="shrink-0 h-[var(--container-height)] w-px bg-[#C0C0C0]"
      />
      <Button
        variant="ghost"
        size="sm"
        // onClick={(e) => {
        //   e.stopPropagation();
        //   onKeyPointsClick?.();
        // }}
        className="w-1/2 shrink-0 h-[var(--container-height)] flex items-center gap-1 cred-md:gap-1.5 px-2 cred-md:px-2.5 cred-lg:px-3 cred-xl:px-3 py-1 cred-md:py-1 cred-lg:py-1.5 cred-xl:py-1.5 rounded-none hover:bg-black/10 text-black hover:text-black [&_svg]:size-4 cred-xl:[&_svg]:size-[18px] 3xl:[&_svg]:size-5"
      >
        <KeyClaimsIcon />
        <span className="text-xs cred-md:text-[13px] cred-lg:text-sm 3xl:text-[15px] font-medium">
          Key Points (<span className="text-[#2979FF]">{keyClaimsCount}</span>)
        </span>
      </Button>
    </div>
  );
};
